import React from 'react'

import Products from '../Components/Products/Products'
import DeBugHeader from '../Components/Header/DeBugHeader'

function Debug() {
  return (
    <div>
        <DeBugHeader></DeBugHeader>
        <Products></Products>
    </div>
  )
}

export default Debug